import React from 'react';
import { Button } from '../../design-system/Button';

interface ComplianceStepProps {
  onComplete: () => void;
  onSkip?: () => void;
  progress?: any;
}

const ComplianceStep: React.FC<ComplianceStepProps> = ({ onComplete, onSkip }) => {
  return (
    <div className="space-y-6">
      <div className="text-center py-8">
        <h3 className="text-lg font-medium text-gray-900 mb-2">
          Compliance & Insurance
        </h3>
        <p className="text-gray-600 mb-6">
          Upload your insurance and compliance documents.
        </p>
        <p className="text-sm text-gray-500">
          This step is optional. You can complete it later from your profile settings.
        </p>
      </div>

      <div className="flex justify-end gap-4">
        {onSkip && (
          <Button onClick={onSkip} variant="secondary" size="lg">
            Skip for Now
          </Button>
        )}
        <Button onClick={onComplete} size="lg">
          Continue
        </Button>
      </div>
    </div>
  );
};

export default ComplianceStep;